import styled from 'styled-components'

export const Table = styled.table`
  width: 90%;
  height: 100%;

  margin: 2% auto;

  @media(max-width: 1300px) {
    width: 90%;
    height: 100%;
  }

`

export const TableHead = styled.thead`
  display: block;
  margin-right: 10px;
`

export const TableBody = styled.tbody`
  display: block;
  height: 85%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #242424;
    border-radius: 20px;
  }

  @media(max-width: 1300px) {
    height: 75%;
  }

`


export const TableRow = styled.tr`
  display: grid;
  grid-template-columns: 100px 0.5fr 0.4fr 0.20fr 120px;
  
  height: 56px;
  cursor: pointer;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;

  font-family: "Space Grotesk";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;

  color: #ffffff;

  &:hover {
    background: #242424;
    transition-delay: 50ms;
  }

  @media (max-width: 1300px) {
    font-size: 15px;
  }

`

export const TableRowHeader = styled(TableRow)`
  &:hover{
    background-color: #333333;
  }
`

export const TableHeadData = styled.th`
`

export const TableData = styled.td`
`

export const Select = styled.select`
  pointer-events: inherit;
  width: 100%;
  height: 40px;
  user-select: none;

  font-family: "Space Grotesk";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;

  @media (max-width: 1300px) {
    font-size: 15px;
  }

`

export const IMG = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
`